import { Flex, Box } from "rebass/styled-components";
import { useStepByStepDispatch, useStepByStepState } from "./StepByStepContext";
import BaseActions from "./BaseActions";
import StepCounter from "./StepCounter";
import { useEffect } from "react";

interface Props {
  children?: React.ReactElement;
  prefill?: boolean;
}
const StepByStep = ({ children, prefill }: Props) => {
  const { active, flow, showSteps } = useStepByStepState();
  const dispatch = useStepByStepDispatch();

  const visible = flow[active];

  useEffect(() => {
    if (active < 0) {
      dispatch({
        type: "changeActive",
        payload: {
          active: 0
        }
      });
    }
  }, [active, dispatch]);

  return (
    <Flex
      flexWrap="wrap"
      width={1}
      pb={[9, 9, 0]}
      sx={{ minHeight: prefill ? [0, "400px"] : "initial" }}
    >
      {showSteps && <StepCounter />}
      {children}
      <Box width={1}>{visible && visible.step}</Box>
      <Box
        width={1}
        py={3}
        mt={[0, 0, 2]}
        mx={[-2, -2, 0]}
        px={[2, 2, 0]}
        sx={{
          backgroundColor: "samoyedWhite",
          borderTop: "default",
          position: ["fixed", "fixed", "relative"],
          bottom: 0,
          zIndex: [1, "initial"]
        }}
      >
        {visible &&
          (visible.CustomAction ? (
            visible.CustomAction
          ) : (
            <BaseActions
              nextLabel={visible.nextLabel}
              prevLabel={visible.prevLabel}
              blockNext={visible.blockNext}
              blockPrev={visible.blockPrev}
            />
          ))}
      </Box>
    </Flex>
  );
};

export default StepByStep;
